import React, { useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../../../Context/AuthContext";
import { canView } from "../../../utils/acl";

import {
  Dashboard,
  Work,
  Business,
  People,
  Assignment,
  Receipt,
  BarChart,
  Folder,
  Settings,
  Language,
  PersonAdd,
  Campaign,
  ExpandMore,
  ChevronRight,
  AccountBalance,
} from "@mui/icons-material";

export default function Sidebar() {
  const location = useLocation();
  const { user } = useContext(AuthContext);

  const [openMenu, setOpenMenu] = useState({
    people: false,
    leads: false,
    taskMenu: false,
    domainMenu: false,
    accountsMenu: false,
  });

  const isActive = (p) => location.pathname === p;
  const isParentActive = (paths) => paths.some((p) => isActive(p));
  const toggle = (m) => setOpenMenu((s) => ({ ...s, [m]: !s[m] }));

  const linkStyle = (active) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 16px",
    margin: "4px 8px",
    borderRadius: "8px",
    color: active ? "#1f2937" : "#cbd5e1",
    background: active ? "#f5f1e6" : "transparent",
    textDecoration: "none",
    fontWeight: active ? "600" : "400",
    transition: "0.3s",
    cursor: "pointer",
  });

  const subLinkStyle = (active) => ({
    padding: "8px 16px",
    margin: "2px 8px",
    borderRadius: "6px",
    color: active ? "#1f2937" : "#9ca3af",
    background: active ? "#f5f1e6" : "transparent",
    textDecoration: "none",
    display: "block",
    fontSize: "14px",
    fontWeight: active ? "600" : "400",
  });

  return (
    <div
      style={{
        width: "240px",
        height: "100vh",
        background: "#003e6d",
        color: "#fff",
        overflowY: "auto",
      }}
    >
      {/* Title */}
      <div style={{ padding: "16px", fontWeight: "bold", fontSize: "18px" }}>
        Admin Dashboard
      </div>

      {/* MENU */}

      {canView(user, "home") && (
        <Link to="/admin/home" style={linkStyle(isActive("/admin/home"))}>
          <span><Dashboard /> Home</span>
        </Link>
      )}

      {canView(user, "jobOpenings") && (
        <Link to="/admin/jobopening" style={linkStyle(isActive("/admin/jobopening"))}>
          <span><Work /> Job Openings</span>
        </Link>
      )}

      {canView(user, "departments") && (
        <Link to="/admin/department" style={linkStyle(isActive("/admin/department"))}>
          <span><Business /> Departments</span>
        </Link>
      )}

      {canView(user, "services") && (
        <Link to="/admin/Service" style={linkStyle(isActive("/admin/Service"))}>
          <span><Business /> Service</span>
        </Link>
      )}

      {/* PEOPLE */}
      {(canView(user, "employees") ||
        canView(user, "trainees") ||
        canView(user, "attendance") ||
        canView(user, "salaries") ||
        canView(user, "projects")) && (
        <>
          <div
            style={linkStyle(isParentActive([
              "/admin/employee",
              "/admin/trainee",
              "/admin/attendance",
              "/admin/salary",
              "/admin/HRIS",
            ]))}
            onClick={() => toggle("people")}
          >
            <span><People /> HRM</span>
            {openMenu.people ? <ExpandMore /> : <ChevronRight />}
          </div>

          {openMenu.people && (
            <div style={{ marginLeft: "10px" }}>
              <Link to="/admin/employee" style={subLinkStyle(isActive("/admin/employee"))}>
                Employees
              </Link>
              <Link to="/admin/trainee" style={subLinkStyle(isActive("/admin/trainee"))}>
                Interns & Trainees
              </Link>
              <Link to="/admin/attendance" style={subLinkStyle(isActive("/admin/attendance"))}>
                Attendance
              </Link>
              <Link to="/admin/AdminSalaryPage" style={subLinkStyle(isActive("/admin/AdminSalaryPage"))}>
                Salaries
              </Link>
              <Link to="/admin/AdminLeavePage" style={subLinkStyle(isActive("/admin/AdminLeavePage"))}>
                Leaves
              </Link>
              {canView(user, "projects") && (
                <Link to="/admin/HRIS" style={subLinkStyle(isActive("/admin/HRIS"))}>
                  HRIS
                </Link>
              )}
            </div>
          )}
        </>
      )}

      {/* LEADS */}
      {(canView(user, "leads") || canView(user, "clients")) && (
        <>
          <div
            style={linkStyle(isParentActive(["/admin/leads", "/admin/client"]))}
            onClick={() => toggle("leads")}
          >
            <span><BarChart /> Leads</span>
            {openMenu.leads ? <ExpandMore /> : <ChevronRight />}
          </div>

          {openMenu.leads && (
            <div style={{ marginLeft: "10px" }}>
              <Link to="/admin/leads" style={subLinkStyle(isActive("/admin/leads"))}>
                Leads
              </Link>
              <Link to="/admin/client" style={subLinkStyle(isActive("/admin/client"))}>
                Clients
              </Link>
            </div>
          )}
        </>
      )}

      {canView(user, "proposals") && (
        <Link to="/admin/PurposalList" style={linkStyle(isActive("/admin/PurposalList"))}>
          <span><Folder /> Proposals</span>
        </Link>
      )}

      {/* TASK */}
      {canView(user, "tasks") && (
        <>
          <div
            style={linkStyle(isParentActive([
              "/admin/TaskList",
              "/admin/EmployeeTask",
            ]))}
            onClick={() => toggle("taskMenu")}
          >
            <span><Assignment /> Task</span>
            {openMenu.taskMenu ? <ExpandMore /> : <ChevronRight />}
          </div>

          {openMenu.taskMenu && (
            <div style={{ marginLeft: "10px" }}>
              <Link to="/admin/TaskList" style={subLinkStyle(isActive("/admin/TaskList"))}>
                Task List
              </Link>
              <Link to="/admin/EmployeeTask" style={subLinkStyle(isActive("/admin/EmployeeTask"))}>
                Employee Task
              </Link>
            </div>
          )}
        </>
      )}

      {canView(user, "invoices") && (
        <Link to="/admin/InvoicesList" style={linkStyle(isActive("/admin/InvoicesList"))}>
          <span><Receipt /> Invoices</span>
        </Link>
      )}

      {canView(user, "reports") && (
        <Link to="/admin/reports" style={linkStyle(isActive("/admin/reports"))}>
          <span><BarChart /> Reports</span>
        </Link>
      )}

      {canView(user, "projects") && (
        <Link to="/admin/getProjectList" style={linkStyle(isActive("/admin/getProjectList"))}>
          <span><Folder /> Projects</span>
        </Link>
      )}

      {canView(user, "users") && (
        <Link to="/admin/CreateUser" style={linkStyle(isActive("/admin/CreateUser"))}>
          <span><PersonAdd /> Create User</span>
        </Link>
      )}

      {canView(user, "noticeBoard") && (
        <Link to="/admin/NoticeBoard" style={linkStyle(isActive("/admin/NoticeBoard"))}>
          <span><Campaign /> Notice Board</span>
        </Link>
      )}

      {canView(user, "company") && (
        <>
          <div
            style={linkStyle(isParentActive(["/admin/domain", "/admin/hosting", "/admin/email", "/admin/subscriptions"]))}
            onClick={() => toggle("domainMenu")}
          >
            <span><Language /> Products</span>
            {openMenu.domainMenu ? <ExpandMore /> : <ChevronRight />}
          </div>

          {openMenu.domainMenu && (
            <div style={{ marginLeft: "10px" }}>
              <Link to="/admin/domain" style={subLinkStyle(isActive("/admin/domain"))}>
                Domains
              </Link>
              <Link to="/admin/hosting" style={subLinkStyle(isActive("/admin/hosting"))}>
                Hosting
              </Link>
              <Link to="/admin/email" style={subLinkStyle(isActive("/admin/email"))}>
                Emails
              </Link>
              <Link to="/admin/subscriptions" style={subLinkStyle(isActive("/admin/subscriptions"))}>
                Subscriptions
              </Link>
            </div>
          )}
        </>
      )}

      {canView(user, "company") && (
        <Link to="/admin/companyDetails" style={linkStyle(isActive("/admin/companyDetails"))}>
          <span><Settings /> Settings</span>
        </Link>
      )}

      <>
        <div
          style={linkStyle(isParentActive(["/admin/accounts", "/admin/add-bank-account", "/admin/income", "/admin/expenses", "/admin/expense-category", "/admin/profit-loss"]))}
          onClick={() => toggle("accountsMenu")}
        >
          <span><AccountBalance /> Accounts</span>
          {openMenu.accountsMenu ? <ExpandMore /> : <ChevronRight />}
        </div>

        {openMenu.accountsMenu && (
          <div style={{ marginLeft: "10px" }}>
            <Link to="/admin/add-bank-account" style={subLinkStyle(isActive("/admin/add-bank-account"))}>
              Add Bank Account
            </Link>
            <Link to="/admin/income" style={subLinkStyle(isActive("/admin/income"))}>
              Income
            </Link>
            <Link to="/admin/expenses" style={subLinkStyle(isActive("/admin/expenses"))}>
              Expenses
            </Link>
            <Link to="/admin/expense-category" style={subLinkStyle(isActive("/admin/expense-category"))}>
              Exp. Category
            </Link>
            <Link to="/admin/profit-loss" style={subLinkStyle(isActive("/admin/profit-loss"))}>
              Report (P/L)
            </Link>
          </div>
        )}
      </>
    </div>
  );
}


